import Facebook from '../src/Facebook';
export default Facebook;
